import { render, staticRenderFns } from "./AdminStateMaterialModal.vue?vue&type=template&id=2eca663d&scoped=true"
import script from "./AdminStateMaterialModal.vue?vue&type=script&lang=js"
export * from "./AdminStateMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./AdminStateMaterialModal.vue?vue&type=style&index=0&id=2eca663d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eca663d",
  null
  
)

export default component.exports